export enum ActivitySuccessResultWithoutDevicesFlowOrder {

    /** Результат работ */
    completeActivityResultStep = 1,
    
    /** Фото документов */
    requiredAttachmentsStep = 2,

    /** Резюме */
    completeActivitySummaryStep = 3,

    /** Подпись */
    completeActivitySignatureStep = 4,

    /** Сохранение результатов */
    saveResults = 5
}